'use client';
import React from 'react';

const whyReasons = [
  { icon: '🏦', text: 'Hand picked offers from', highlight: '50+ lenders' },
  { icon: '⚡', text: 'Money in Mins via', highlight: 'Pre-Approved Loans' },
  { icon: '✅', text: 'Instant', highlight: 'Sanction & Disbursal' },
];

const videoTestimonials = [
  {
    id: 1,
    name: 'Rahul Mehta',
    location: 'Mumbai',
    quote: 'KARFIN supported me financially when I needed it the most.',
    bg: 'from-blue-500 to-blue-700',
    emoji: '👨‍💼',
  },
  {
    id: 2,
    name: 'Anita Sharma',
    location: 'Delhi',
    quote: 'KARFIN showed how a little financial support at the right time can make all the difference.',
    bg: 'from-purple-500 to-purple-700',
    emoji: '👩‍💼',
  },
  {
    id: 3,
    name: 'Dr. Suresh Gupta',
    location: 'Gurgaon',
    quote: 'Some dreams are special long before they are realized. KARFIN helped me achieve mine.',
    bg: 'from-teal-500 to-teal-700',
    emoji: '👨‍⚕️',
  },
  {
    id: 4,
    name: 'Kavita Reddy',
    location: 'Hyderabad',
    quote: 'Turning a Dream into Growth — that\'s what KARFIN did for my business.',
    bg: 'from-orange-500 to-orange-700',
    emoji: '👩‍💻',
  },
];

export default function VideoTestimonialsSection() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Left side */}
          <div className="lg:w-64 flex-shrink-0">
            <p className="text-xs font-semibold text-primary uppercase tracking-wider mb-2">Video Testimonials</p>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Why Customers Choose Us</h2>
            <ul className="space-y-4">
              {whyReasons?.map((reason) => (
                <li key={reason?.highlight} className="flex items-start gap-3">
                  <span className="text-xl flex-shrink-0">{reason?.icon}</span>
                  <div className="text-sm text-gray-500">
                    {reason?.text}{' '}
                    <span className="font-semibold text-gray-900">{reason?.highlight}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Video cards */}
          <div className="flex-1 grid grid-cols-2 lg:grid-cols-4 gap-4">
            {videoTestimonials?.map((vt) => (
              <div
                key={vt?.id}
                className={`relative rounded-xl overflow-hidden cursor-pointer group bg-gradient-to-b ${vt?.bg}`}
                style={{ minHeight: '200px' }}
              >
                {/* Play button overlay */}
                <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                  <div className="text-5xl mb-3 group-hover:scale-110 transition-transform duration-300">{vt?.emoji}</div>
                  <div className="w-10 h-10 rounded-full bg-white bg-opacity-30 flex items-center justify-center mb-3 group-hover:bg-opacity-50 transition-all">
                    <svg className="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                  <p className="text-white text-xs text-center leading-tight opacity-90">{vt?.quote}</p>
                </div>

                {/* Name overlay at bottom */}
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-40 px-3 py-2">
                  <p className="text-white text-xs font-semibold">{vt?.name}</p>
                  <p className="text-white text-xs opacity-70">{vt?.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
